module.exports = __webpack_public_path__ + "img/tyres.e9131616.jpg";